<template>
  <component :is="layout" :options="options" @dynamic-event="onEvent"></component>
</template>

<script>
import tmplDefault from '@/templates/default/components/list'
//  import tmplCanalSur from '@/templates/default/components/list'

export default {
  name: 'ContentDetail',
  props: ['options'],
  components: {
    'tmpl-DFT': tmplDefault, // defecto
    // 'tmpl-PIN': tmplPinkoTV, // Pinko TV
    // 'tmpl-PLN': tmplPlay, // Play
    // 'tmpl-PLY': tmplPlayTrailer, // Play + trailer
    // 'tmpl-APP': tmplApple, // Apple
    'tmpl-SUR': tmplDefault // Canal Sur
  },
  computed: {
    layout () {
      let layout = 'tmpl-' + this.$store.getters.getData.template1

      // // CONTENIDOS
      // if (this.$route.name === 'content') {
      //   // Plantilla pantalla principal de contenidos (root-categories)
      //   layout = 'tmpl-' + this.$store.getters.getData.template1
      // } else if (this.$route.name === 'content-category') {
      //   // Plantilla pantalla anidada de contenidos (sub-category)
      //   layout = 'tmpl-' + this.$store.getters.getData.template2
      // } else if (this.$route.name === 'content-detail') {
      //   // Plantilla pantalla precontenido de contenidos (content-preview)
      //   layout = 'tmpl-' + this.$store.getters.getData.template5
      // }

      // // TIENDA
      // if (this.$route.name === 'shop') {
      //   // Plantilla pantalla principal de productos (root-contents)
      //   layout = 'tmpl-' + this.$store.getters.getData.template3
      // } else if (this.$route.name === 'shop-category') {
      //   // Plantilla pantalla anidada de productos (sub-category)
      //   layout = 'tmpl-' + this.$store.getters.getData.template4
      // } else if (this.$route.name === 'product') {
      //   // Plantilla pantalla precontenido de productos (product)
      //   layout = 'tmpl-' + this.$store.getters.getData.template6
      // }

      return this.$options.components[layout] ? layout : 'tmpl-DFT'
    }
  },
  methods: {
    onEvent (event, params) {
      this.$emit(event, params)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/List.vue